import React from "react";
import styled from "styled-components";
import { Typography } from "@beamcloud/design-system";

type Size = "base" | "small";

interface IProps {
  category: string;
  size?: Size;
  className?: "";
  onClick?: () => any;
}

const Category = ({ className, category, size = "base", onClick }: IProps) => {
  return (
    <Pill className={className} onClick={onClick}>
      <Typography tag="span" variant={size === "base" ? "textBase" : "textSm"} color="gray300">
        {category}
      </Typography>
    </Pill>
  );
};

export default Category;

const Pill = styled.div`
  padding: 2px 8px;
  background: ${props => props.theme.colors.gray850};
  border: 1px solid ${props => props.theme.colors.gray7};
  border-radius: 8px;
  margin: 0;
`;
